import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "./style.css";
import testimonial from "../../../data/testimonial";

function Testimonials() {
  return (
    <Swiper
      slidesPerView={2}
      spaceBetween={30}
      pagination={{
        clickable: true,
      }}
      navigation={{
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      }}
      modules={[Pagination, Navigation]}
      className="my_wiper_2 pt-5"
    >
      {testimonial.testimonials.map((item, index) => (
        <SwiperSlide key={index}>
          <div className="d-flex align-items-center justify-content-between px-4 me-3">
            <img src={item.img} alt="img" className="celeb_img" />

            <div className="ms-4">
              <img
                src={item.icon}
                alt="icon"
                className="d-flex justify-content-start"
              />
              <p className="my-3 text-start">{item.text}</p>
              <p className="text-start fw-bold">{item.name}</p>
            </div>
          </div>
        </SwiperSlide>
      ))}

      <button className="swiper-button-prev">
        <span>Prev</span>
      </button>

      <button className="swiper-button-next">
        <span>Next</span>
      </button>
    </Swiper>
  );
}

export default Testimonials;
